"use client";

import { getRedirectUrlFromSearch } from "@/lib/utils/auth-redirect";
import { useRouter, useSearchParams } from "next/navigation";
import { ErrorContext } from "better-auth/react";
import { useState } from "react";

export function useAuthForm(defaultRedirect = "/creator") {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const redirectUrl = getRedirectUrlFromSearch(searchParams, defaultRedirect);
  const onSuccess = () => router.replace(redirectUrl);
  const onError = ({ error }: ErrorContext) =>
    setErrorMessage(error?.message ?? "An error occurred. Please try again.");

  const clearError = () => setErrorMessage(null);

  return {
    errorMessage,
    redirectUrl,
    onSuccess,
    onError,
    clearError,
  };
}
